const ua: string = navigator.userAgent;

export interface IDeviceDetection {
  iphone: boolean;
  ipod: boolean;
  ipad: boolean;
  blackberry: boolean;
  playbook: boolean;
  android: boolean;
  macOS: boolean;
  win: boolean;
  mac: boolean;
  linux: boolean;
  wphone: boolean;
  mobile: boolean;
  androidTablet: boolean;
  tabletPc: boolean;
  palmDevice: boolean;
  kindle: boolean;
  otherMobileHints: boolean;
  chrome: boolean;
  safari: boolean;
  webkit: boolean;
  ie: boolean;
  ie11: boolean;
  edge: boolean;
  firefox: boolean;
  isTouchDevice: () => boolean;
  isMac: () => boolean;
  isApple: () => boolean;
  isBlackberry: () => boolean;
  isAndroid: () => boolean;
  isTablet: () => boolean;
  isDesktop: () => boolean;
  isSmartPhone: () => boolean;
  isIOS: () => boolean;
  isLowPerformanceDevice: () => boolean;
  isWebGLAvailable: () => boolean;
  isIE: () => boolean;
  setCssClassOnBody: () => void;
  isSmartphoneDisplay: boolean;
}

/**
 * Gibt eine Reihe von Check-Funktionen und boolschen Flags zurück, um Informationen über das aktuelle Device zu erhalten
 */
export const DeviceDetection: IDeviceDetection = {
  iphone: /iPhone/i.test(ua),
  ipod: /iPod/i.test(ua),
  ipad: /iPad/i.test(ua),
  blackberry: /BlackBerry/i.test(ua),
  playbook: /PlayBook/i.test(ua),
  android: /Android/i.test(ua),
  macOS: /Mac OS X/i.test(ua),
  win: /Windows/i.test(ua),
  mac: /Macintosh/i.test(ua),
  linux: /(Linux|X11)/i.test(ua),
  wphone: /(Windows Phone OS|Windows CE|Windows Mobile)/i.test(ua),
  mobile: /Mobile/i.test(ua),
  // http://mojosunite.com/tablet-user-agent-strings
  androidTablet: /(GT-P1000|SGH-T849|SHW-M180S)/i.test(ua),
  tabletPc: /Tablet PC/i.test(ua),
  palmDevice: /(PalmOS|PalmSource| Pre\/)/i.test(ua),
  kindle: /(Kindle)/i.test(ua),
  otherMobileHints: /(Opera Mini|IEMobile|SonyEricsson|smartphone)/i.test(ua),
  chrome: /chrome/i.test(ua) && /Google/i.test(navigator.vendor),
  safari: /safari/i.test(ua) && /Apple/i.test(navigator.vendor),
  webkit: /AppleWebKit/i.test(ua),
  ie: /MSIE/i.test(ua),
  ie11: !!window.MSInputMethodContext && !!document.documentMode,
  edge: /Edge\/\d+/i.test(ua),
  firefox: /firefox/i.test(ua),

  isTouchDevice: (): boolean =>
    DeviceDetection.iphone || DeviceDetection.ipod || DeviceDetection.ipad,
  isMac: (): boolean => DeviceDetection.macOS || DeviceDetection.mac,
  isApple: (): boolean =>
    DeviceDetection.iphone ||
    DeviceDetection.ipod ||
    DeviceDetection.ipad ||
    DeviceDetection.macOS ||
    DeviceDetection.mac,
  isBlackberry: (): boolean => DeviceDetection.blackberry,
  isAndroid: (): boolean => DeviceDetection.android,
  isTablet: (): boolean =>
    DeviceDetection.ipad ||
    DeviceDetection.playbook ||
    DeviceDetection.androidTablet ||
    DeviceDetection.kindle,
  isDesktop: (): boolean =>
    !DeviceDetection.isTouchDevice() &&
    !DeviceDetection.isSmartPhone() &&
    !DeviceDetection.isTablet(),
  isSmartPhone: (): boolean =>
    (DeviceDetection.mobile ||
      DeviceDetection.blackberry ||
      DeviceDetection.palmDevice ||
      DeviceDetection.otherMobileHints) &&
    !DeviceDetection.isTablet() &&
    !DeviceDetection.ipod,
  isIOS: (): boolean => DeviceDetection.iphone || DeviceDetection.ipod || DeviceDetection.ipad,
  isLowPerformanceDevice: (): boolean =>
    /* TODO hier besserer Ansatz? Ist halt sehr von der speziellen Szene und den Modellen / Browser abhängig*/ false,
  isWebGLAvailable: (): boolean => {
    try {
      let canvas: HTMLCanvasElement = document.createElement("canvas");
      return !!(
        window.WebGLRenderingContext &&
        (canvas.getContext("webgl") || canvas.getContext("experimental-webgl"))
      );
    } catch (e) {
      return false;
    }
  },
  isIE: (): boolean => DeviceDetection.ie || DeviceDetection.ie11,
  setCssClassOnBody: (): void => {
    if (DeviceDetection.isIOS()) {
      document.body.classList.add("ua-ios");
    }
  },

  isSmartphoneDisplay: ((): boolean => {
    // Tablets sollen false und Smartphones true ergeben. Die Seite soll zudem responsive sein.
    // CSS und JS soll gleich sein. Nach eingehendem Einlesen in die Materie:
    // Einzige brauchbare Einheit für Media Queries sind px (Safari hat Bugs bei em).
    // Die kürzeste Seite des kleinsten Tabletts (600px) ist größer als die kürzeste Seite des größten
    // Handies (https://www.mydevice.io/#compare-devices).
    return Math.min(window.innerWidth, window.innerHeight) < 600; // corrected window.offsetWidth/offsetHeight to innerWidth/Height as window doesn't have offsetWidth usually, or maybe it was intended for body? checking logic.
  })(),
};

DeviceDetection.setCssClassOnBody();
